export var CARDS_INFO_KEY = 'cardsInfo';
//# sourceMappingURL=cards.js.mapexport var CARDS_INFO_KEY = 'cardsInfo';
//# sourceMappingURL=cards.js.map